import { useState, useEffect, useCallback } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import PartnersSlider from "./PartnersSlider";
import Panel from "./panel";
import TemplateSlider from "./TemplateSlider";
import Faq from "./Faq";
import { getApiErrorMessage, validateEmail } from "../../utils/commonUtils";
import { GoogleLogin } from "@react-oauth/google";
import { toast } from "../../utils/ToastNotification.jsx";

import effectImage from "../../assets/image/landing-effect1.webp";
import Contract from "../../assets/image/contract-asset.webp";
import DarkContract from "../../assets/image/contract-asset-dark.webp";
import User1 from "../../assets/image/user1.webp";
import User2 from "../../assets/image/user2.webp";
import User3 from "../../assets/image/user3.webp";
import Faqeffect from "../../assets/image/faq-effect.webp";
import SliderEffect from "../../assets/image/slider-effect.webp";
import { useDispatch, useSelector } from "react-redux";
import { setUserInfo } from "../../redux/slices/userSlice";
import { getRefreshToken, setTokens } from "../../utils/browserStorage";
import useApi from "../../hooks/useApi.js";
import {
  GOOGLE_LOGIN,
  REFRESH_ACCESS_TOKEN,
  USER_LOGIN,
  USER_VERIFICATION,
} from "../../utils/apiConstants";
import paths from "../../utils/paths.js";
import styles from "./landingPage.module.css";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export default function LandingPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = location.state?.redirectTo;
  const userInfo = useSelector((state) => state.userInfo);
  const dispatch = useDispatch();
  const { apiRequest, loading } = useApi();
  const mode = useSelector((state) => state.theme.mode);

  const [isLogin, setIsLogin] = useState(false);
  const [email, setemail] = useState("");
  const [emailerr, setemailerr] = useState(false);
  const [password, setpassword] = useState("");
  const [passworderr, setpassworderr] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };
  const isDarkMode = mode !== "light";

  const googleloginfrom = async (value) => {
    const decoded = jwtDecode(value.credential || "");
    const data = {
      email: decoded.email,
    };
    try {
      const response = await apiRequest({
        url: GOOGLE_LOGIN,
        method: "post",
        data: data,
      });
      const { accessToken, refreshToken } = response.data;
      setTokens({ accessToken, refreshToken });

      navigate(redirectTo || paths.Profile);
    } catch (error) {
      toast.error(getApiErrorMessage(error, "Login failed"));
      console.log("error in google login:", error);
    }
  };

  const handleLogin = async () => {
    let hasError = false;

    if (email === "" || !validateEmail(email)) {
      setemailerr(true);
      hasError = true;
    } else {
      setemailerr(false);
    }
    if (password === "") {
      setpassworderr(true);
      hasError = true;
    } else {
      setpassworderr(false);
    }
    if (hasError) return;

    const obj = { email, password };
    try {
      const response = await apiRequest({
        url: USER_LOGIN,
        method: "post",
        data: obj,
      });
      const { accessToken, refreshToken } = response.data;
      setTokens({ accessToken, refreshToken });
      if (response.status === true) {
        toast.success(response.data.Message);
        navigate(redirectTo || paths.Profile);
      } else {
        toast.error(response.data.Message);
      }
    } catch (error) {
      console.log("Error in LoginHandler :", error);
      toast.error(getApiErrorMessage(error, "Login failed"));
    }
  };

  const checkAuthentication = useCallback(async () => {
    try {
      const refreshToken = getRefreshToken();
      if (!refreshToken) return;
      const response = await apiRequest({
        url: REFRESH_ACCESS_TOKEN,
        method: "post",
        data: { refreshToken },
      });
      if (response?.data) {
        const { accessToken, ...userInfo } = response.data;
        localStorage.setItem("accessToken", accessToken);
        dispatch(setUserInfo(userInfo));
      } else {
        console.error("Invalid response structure", response);
      }
    } catch (error) {
      console.log("error in the checkAuthentication:", error);
    }
  }, [apiRequest, dispatch]);

  const verifyEmail = useCallback(async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get("id");
      if (!id) return;
      const response = await apiRequest({
        url: USER_VERIFICATION,
        method: "post",
        data: { id },
      });
      if (response.status === true) {
        toast.success("Email verification completed, login to continue.");
        navigate("/");
      } else {
        toast.error("Email verification failed.");
      }
    } catch (error) {
      console.error("Error verifying email:", error);
      toast.error("An error occurred during email verification.");
    }
  }, [apiRequest, navigate]);

  useEffect(() => {
    checkAuthentication();
    verifyEmail();
  }, [checkAuthentication, verifyEmail]);

  useEffect(() => {
    if (userInfo?.userId) {
      setIsLogin(true);
    } else {
      setIsLogin(false);
    }
  }, [userInfo]);

  return (
    <>
      <div className="position-relative">
        <div className={`${styles.landingEffect}`}>
          <img
            src={effectImage}
            alt="Header"
            fetchpriority="high"
            decoding="async"
          />
        </div>
      </div>
      <section className="px-3">
        <div className={`${styles.main_content}`}>
          <div>
            <h1 className="txt-gradient">Law Blocks AI</h1>
            <p className={`${styles.description} txt-black`}>
              Simplify Legal Complexities, powered by AI. Clarify and solve all
              your Legal Barriers <br />
              with Law Blocks AI
              {!isLogin && ", Sign Up Now"}
            </p>
          </div>
          <div className={`${styles.form_container} mt-4`}>
            {isLogin === false && (
              <>
                <div>
                  <TextField
                    fullWidth
                    type="email"
                    onChange={(e) => {
                      setemail(e.target.value);
                      setemailerr(false);
                    }}
                    placeholder="Enter your email Id"
                    className="input-styles"
                  />
                  <span className="text-danger">
                    {emailerr && "Invalid Email address"}
                  </span>

                  <TextField
                    fullWidth
                    type={showPassword ? "text" : "password"}
                    onChange={(e) => {
                      setpassword(e.target.value);
                      setpassworderr(false);
                    }}
                    placeholder="Enter your password"
                    className="input-styles mt-4"
                    slotProps={{
                      input: {
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showPassword ? "Hide password" : "Show password"
                              }
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              onMouseUp={handleMouseUpPassword}
                              edge="end"
                            >
                              {!showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                  {passworderr ? (
                    <span className="text-danger">Password is required</span>
                  ) : (
                    <div className="d-flex justify-content-end">
                      <NavLink
                        to={paths.ForgotPassword}
                        className="mt-2 txt-purple"
                      >
                        Forgot password
                      </NavLink>
                    </div>
                  )}
                </div>

                <div className="mt-5 text-center d-flex flex-column align-items-center gap-3">
                  {loading === false ? (
                    <button
                      onClick={handleLogin}
                      className="gradientButton py-2 px-4 rounded fw-bold"
                    >
                      Login
                    </button>
                  ) : (
                    <button className="gradientButton py-2 px-4 rounded fw-bold">
                      Loading...
                    </button>
                  )}

                  <p className="txt-black m-0">OR</p>

                  <button className={`${styles.google_btn}`}>
                    <GoogleLogin
                      onSuccess={googleloginfrom}
                      onError={() => {
                        toast("Loign Faild!");
                      }}
                    />
                  </button>
                  <p className="m-0">
                    <span className="txt-dimBlack">
                      Don't have an account?{" "}
                    </span>
                    <NavLink
                      to={paths.Register}
                      state={{ redirectTo }}
                      className="txt-purple"
                    >
                      Register
                    </NavLink>
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      </section>

      <section className="slider-section card-shadow">
        <PartnersSlider />
      </section>

      <section className="panel-section">
        <Panel />
      </section>

      <section className="template-slider-section">
        <div className="slider-effect">
          <img loading="lazy" src={SliderEffect} alt="effect" />
        </div>
        <div className="px-3">
          <div className={`${styles.panel_content} ${styles.contract_content}`}>
            <div>
              <h2>Legal Template</h2>
              <p>
                Law Blocks AI offers ready-made legal templates tailored to your
                needs, saving time and ensuring accuracy. Easily customize
                agreements with AI assistance for quick, professional results.
              </p>
            </div>
          </div>
          <TemplateSlider />
        </div>
      </section>

      <section className="contract-section">
        <div className="px-3">
          <div className={`${styles.panel_content} ${styles.contract_content}`}>
            <div className="">
              <h2>How Smart Legal Contract Works</h2>
              <p>
                Law Blocks is a one window blockchain-based ecosystem for
                creating, keeping records of smart legal contracts.
              </p>
              {isDarkMode ? (
                <img
                  loading="lazy"
                  src={Contract}
                  alt="Header"
                  width={"100%"}
                />
              ) : (
                <img
                  loading="lazy"
                  src={DarkContract}
                  alt="Header"
                  width={"100%"}
                />
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="contract-section about-us">
        <div className="px-3">
          <div
            className={`${styles.panel_content} ${styles.contract_content} ${styles.panel_content1}`}
          >
            <div>
              <h2> Our happy Users says about us</h2>
              <p className="user-p">
                10k+ User those who already tried our services.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="about-card card-shadow">
                <div className="ratings">
                  <div>
                    <img
                      src={User1}
                      alt="Header"
                      width={"80px"}
                      className="user-top"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                </div>
                <div className="about-content">
                  I had a complex dispute that needed resolution, and Law Blocks
                  AI came to the rescue. Their blockchain-powered arbitration
                  process provided a fair, transparent, and expedited
                  resolution.
                </div>
                <div className="about-name">
                  <h4>
                    Kyle Roberts DVM <br />
                    <span>Attorney</span>
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="about-card card-shadow">
                <div className="ratings">
                  <div>
                    <img
                      src={User2}
                      alt="Header"
                      width={"80px"}
                      className="user-top"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                </div>
                <div className="about-content">
                  Law Blocks has completely transformed how I approach dispute
                  resolution. With their seamless integration of smart contracts
                  and blockchain technology, the process has become faster, more
                  transparent, and cost-effective. Highly recommended!
                </div>
                <div className="about-name">
                  <h4>
                    Vaibhav Shashikan
                    <br />
                    <span>Attorney</span>
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="about-card card-shadow">
                <div className="ratings">
                  <div>
                    <img
                      src={User3}
                      loading="lazy"
                      alt="Header"
                      width={"80px"}
                      className="user-top"
                    />
                  </div>
                  <div>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                </div>
                <div className="about-content">
                  I had a complex dispute that needed resolution, and Law Blocks
                  came to the rescue. Their blockchain-powered arbitration
                  process provided a fair, transparent, and expedited
                  resolution.
                </div>
                <div className="about-name">
                  <h4>
                    Stephen Brekke <br />
                    <span>Attorney</span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="faq-section">
        <div>
          <img
            loading="lazy"
            src={Faqeffect}
            alt="faq effect"
            className="faq-effect"
          />
        </div>
        <Faq />
      </section>
    </>
  );
}
